export const latinize = (str: string) =>
  str
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/\u0141/g, 'L') // Ł
    .replace(/\u0142/g, 'l') // ł
